// eslint-disable-next-line import/prefer-default-export
export const useQuery = (useLocation) => {
  if (!useLocation) return {}

  const { search } = useLocation() || {}

  const queries = new URLSearchParams(search)

  return queries
}

export const toQuery = (queries) => {
  let query = '?'

  Object.keys(queries).forEach((name) => {
    const value = queries[name]

    if (Array.isArray(value)) {
      value.map((item) => {
        const separete = '&'

        query += `${separete}${name}[]=${encodeURIComponent(item)}`
        return null
      })
    } else if (value) {
      const separete = '&'

      query += `${separete}${name}=${value}`
    }
  })

  return query
}
